export const EATING_TAGS = [
  { text: "hungry", emoji: "🍽️" },
  { text: "it was time", emoji: "⏰" },
  { text: "social", emoji: "🫱🏻‍🫲🏽" },
  { text: "bored", emoji: "😐" },
  { text: "stressed", emoji: "😣" },
  { text: "cravings", emoji: "🤤" },
  { text: "tired", emoji: "😴" },
  { text: "love the taste", emoji: "😋" },
  { text: "why not", emoji: "🤷" },
  { text: "only food available", emoji: "🥣" },
  { text: "other", emoji: "🍱" },
];
